import { useId } from '@radix-ui/react-id'
import Image from 'next/image'
import { ComponentProps } from 'react'
import { Stack } from '../Stack'
import {
  CheckboxContainer,
  CheckboxIcon,
  CheckboxInput,
  CheckboxLabelIcon,
  CheckboxRoot,
} from './Checkbox.styles'

type CheckboxOwnProps = ComponentProps<typeof CheckboxInput>

export type CheckboxProps = CheckboxOwnProps & {
  label: string | React.ReactNode
  hiddenLabel?: boolean
  name?: string
  variant?: 'primary' | 'secondary' | 'primaryRed' | 'unavailable'
  customCSS?: any
  labelIcon?: { src: string; height: number; width: number; iconCSS?: any }
  labelSize?: number
  checkboxSize?: 'small' | 'medium' | 'large' | '24'
}

export const Checkbox = ({
  id,
  label,
  hiddenLabel = false,
  disabled,
  name,
  checked,
  customCSS,
  labelIcon,
  checkboxSize,
  variant,
  ...rest
}: CheckboxProps) => {
  const checkboxId = useId(id)

  return (
    <CheckboxRoot disabled={disabled} css={customCSS} variant={variant}>
      <CheckboxContainer size={checkboxSize}>
        <CheckboxInput
          type="checkbox"
          id={checkboxId}
          aria-label={hiddenLabel ? (label as string) : undefined}
          disabled={disabled}
          name={name}
          checked={checked}
          {...rest}
        />
        <CheckboxIcon name="check-fill" />
      </CheckboxContainer>
      {!hiddenLabel && (
        <label style={{ width: '100%' }} htmlFor={checkboxId}>
          <Stack direction="row" alignItems="center" css={customCSS}>
            {labelIcon && (
              <CheckboxLabelIcon size={labelIcon.iconCSS?.size}>
                <Image
                  src={labelIcon.src}
                  height={labelIcon.height}
                  width={labelIcon.width}
                  alt={label as string}
                  style={{ color: labelIcon.iconCSS?.color }}
                />
              </CheckboxLabelIcon>
            )}
            {label}
          </Stack>
        </label>
      )}
    </CheckboxRoot>
  )
}

Checkbox.displayName = 'Checkbox'
